import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createAddBonusModel } from 'features/add-bonus';
import { createBlockBonusModel } from 'features/block-bonus';
import { createDeleteBonusModel } from 'features/delete-bonus';
import { createEditBonusModel } from 'features/edit-bonus';
import { createUnblockBonusModel } from 'features/unblock-bonus';
import { accountTreeModel } from 'entities/account';
import { createBonusRegistryModel } from 'entities/bonus';

const addBonusModel = createAddBonusModel();

const editBonusModel = createEditBonusModel();

const blockBonusModel = createBlockBonusModel();

const unblockBonusModel = createUnblockBonusModel();

const deleteBonusModel = createDeleteBonusModel();

const bonusRegistryModel = createBonusRegistryModel({
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteBonusModel.mutation.finished.success],
	onUpdate: [
		addBonusModel.addBonusMutation.finished.success,
		editBonusModel.editBonusMutation.finished.success,
		blockBonusModel.mutation.finished.success,
		unblockBonusModel.mutation.finished.success,
	],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: bonusRegistryModel.model.filters.accountIds.setValue,
});

chain(bonusRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const bonusesPageModel = {
	bonusRegistryModel,
	addBonusModel,
	editBonusModel,
	blockBonusModel,
	unblockBonusModel,
	deleteBonusModel,
};
